// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"eec11f6a","703":"a35998a3"}[chunkId] + ".chunk.js";
};